/* eslint-disable react/prop-types */
import { useContext } from "react";
import api from "../../../services/axiosConfig";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { formatarMoeda, formatarMoedaDolar } from "../../../utils/formatMoeda";
import { Button } from "reactstrap";
import { Context } from "../../../hooks/useAuthContext";

function CardNF({
  isEmiting,
  values,
  tipoContaNF,
  dataInicio,
  dataFim,
  nfId,
  status,
  statusPagamento,
  buscarNotasFiscais,
  selectedDatePeriod,
  tipoNota,
}) {
  const { userData } = useContext(Context);

  const formatarData = (timestamp) => {
    const data = new Date(timestamp);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const handleCancelarNota = async () => {
    const confirm = await Swal.fire({
      title: "Cancelar Nota Fiscal?",
      text: "Essa ação não poderá ser revertida.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, cancelar",
      cancelButtonText: "Voltar",
    });

    if (confirm.isConfirmed) {
      try {
        await api.patch(`/nf/cancelar-nota/${nfId}`, { status: "cancelado" });
        toast.success("Nota fiscal cancelada com sucesso!");
        await buscarNotasFiscais(selectedDatePeriod);
      } catch (error) {
        console.error("Erro ao cancelar a nota fiscal:", error);
        toast.error("Erro ao cancelar a nota fiscal.");
        throw new Error("Erro ao cancelar a nota fiscal:", error);
      }
    }
  };

  const handleWarn = () => {
    const text = `Para garantir o pagamento,
a nota fiscal do mês corrente deve ser enviada até o dia 10. <br /> <br /> 
Notas enviadas até às 16h do dia 01 (dia útil) serão pagas no mesmo dia. <br /> <br /> 
As notas enviadas entre os dias 02 e 10 serão pagas no dia 11 (ou próximo dia útil). <br /> <br /> 
Caso a nota não seja emitida até o dia 10 do mês seguinte, o valor será doado, caracterizando renúncia ao recebimento.<br /><br />  
A medida visa maior previsibilidade e agilidade nos pagamentos.`;

    Swal.fire({
      title: "Sobre o Pagamento",
      html: text,
      icon: "warning",
    });
  };

  return (
    <div className="cardNF">
      <h3 className="NfTitle">Referencia de receita</h3>
      <h5 className="NfDate">
        {formatarData(dataInicio)} a {formatarData(dataFim)}{" "}
      </h5>

      <div className="NfContent">
        {tipoNota === "comissao" ? (
          <>
            <div className="NfRow">
              <span className="NfLabel">Total em dólar</span>
              <span className="value positive">
                $
                {formatarMoedaDolar(
                  values?.receitaBruta || values?.totalDolar || values?.valorEmReal
                )}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Cotação do dólar</span>
              <span className="value positive">
                ${formatarMoedaDolar(values?.cotacaoDolar)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Valor em real</span>
              <span className="value positive">
                R$ {formatarMoeda(values?.valorEmReal)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Sua Porcentagem</span>
              <span className="value positive">{values?.porcentagemDivisao}</span>
            </div>
          </>
        ) : (
          <>
            <div className="NfRow">
              <span className="NfLabel">Total em dólar</span>
              <span className="value positive">
                ${formatarMoedaDolar(values?.receitaBruta || values?.totalDolar)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Taxa do Google</span>
              <span className="value positive">{values?.taxaGoogle}</span>
            </div>
            {(tipoContaNF === "usuario" || userData?.tipoConta === "usuario") && (
              <div className="NfRow">
                <span className="NfLabel">Taxa da plataforma</span>
                <span className="value positive">{values?.taxaPlataforma}</span>
              </div>
            )}
            <div className="NfRow">
              <span className="NfLabel">Líquido em dólar</span>
              <span className="value positive">
                ${formatarMoedaDolar(values?.totalLiquido || values?.liquidoDolar)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Cotação do dólar</span>
              <span className="value positive">
                ${formatarMoedaDolar(values?.cotacaoDolar)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Valor em real</span>
              <span className="value positive">
                R$ {formatarMoeda(values?.valorEmReal)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Descontos</span>
              <span className="value negative">
                - R$ {formatarMoeda(values?.descontos || values?.totalDescontos)}
              </span>
            </div>
            <div className="NfRow discountItem">
              <span>{values?.obsDesconto && `${values?.obsDesconto}`}</span>
            </div>
            <hr className="divider" />
          </>
        )}

        <div className="NfRow">
          <span className="NfLabel">
            Sua {tipoNota === "comissao" ? "comissão" : "parte"}
          </span>
          <span className="value positive">
            R$ {formatarMoeda(values?.valorEmRealComDesconto)}
          </span>
        </div>

        <div className="NfRow">
          <span className="NfLabel">Data para pagamento</span>
          <span
            className="value paymentWarn"
            style={{ cursor: "pointer" }}
            onClick={handleWarn}
          >
            Ver mais
          </span>
        </div>

        {(status || values?.status) && (
          <div className="NfRow">
            <span className="NfLabel">Status</span>
            <span
              className={`value ${
                values?.status || status === "pendente"
                  ? "pendent"
                  : values?.status || status === "cancelado"
                  ? "cancelled"
                  : values?.status || status === "emitida"
                  ? "issued"
                  : values?.status || status === "pago"
                  ? "payed"
                  : ""
              }`}
            >
              {values?.status || status}
            </span>
          </div>
        )}

        {(userData?.tipoConta === "usuario" ||
          userData?.tipoConta === "influenciador") &&
          !isEmiting && (
            <div className="NfRow">
              <span className="NfLabel">Status pagamento</span>
              <span className="value">{statusPagamento}</span>
            </div>
          )}

        {!isEmiting &&
          status !== "cancelado" &&
          status !== "pago" && (
            <Button
              color="danger"
              style={{ marginTop: "1rem" }}
              onClick={handleCancelarNota}
            >
              Cancelar Nota Fiscal
            </Button>
          )}
      </div>
    </div>
  );
}

export default CardNF;